import Default from '@app/constants';
import { clearFilterBatteriesWinnonie } from '@app/modules/winnonie/containers/batteries/manageTemplate';
import {
  clearFilterEvLockersBrandWinnonie,
  clearFilterEvLockersProjectWinnonie,
} from '@app/modules/winnonie/containers/evLockers/manageTemplate';
import { clearFilterBatteryLogsWinnonie } from '@app/modules/winnonie/containers/logs/battery/manageTemplate';
import {
  clearFilterEvLockerLogsBrandWinnonie,
  clearFilterEvLockerLogsProjectWinnonie,
} from '@app/modules/winnonie/containers/logs/evLocker/manageTemplate';
import { clearFilterRiderWinnonie } from '@app/modules/winnonie/containers/logs/rider/manageTemplate';
import {
  clearFilterStationLogsBrandWinnonie,
  clearFilterStationLogsProjectWinnonie,
} from '@app/modules/winnonie/containers/logs/station/manageTemplate';
import {
  clearFilterTransactionsBrandWinnonie,
  clearFilterTransactionsProjectWinnonie,
} from '@app/modules/winnonie/containers/logs/transaction/manageTemplate';
import { clearFilterStationsWinnonie } from '@app/modules/winnonie/containers/stations/manageTemplate';
import { clearFilterUsersWinnonie } from '@app/modules/winnonie/containers/users/manageTemplate';
import { EndUserManageTable, FilterEndUser } from '@app/typings/services/user';
import { get, set, rm } from 'lockr';

const defaultTableEndUser: string = 'keyspace/project.endUser.manageTable';
const filterEndUser: string = 'keyspace/project.endUser.filters';

// Manage Table //

export const setManageTableEndUser = (value: EndUserManageTable) => {
  set(defaultTableEndUser, value);
};
export const getManageTableEndUser = (): EndUserManageTable => {
  return get(defaultTableEndUser) || Default.manageTable.projectEndUser;
};

// Filters //

export const setFilterProjectEndUser = (value: FilterEndUser) => {
  set(filterEndUser, value);
};
export const getFilterProjectEndUser = (): FilterEndUser => {
  return get(filterEndUser) || { filters: Default.filter.projectEndUser, pages: Default.pages };
};
export const clearFilterProjectEndUser = () => {
  return rm(filterEndUser);
};

// ETC //

export const clearFilterBrandLevel = () => {
  clearFilterUsersWinnonie();
  clearFilterRiderWinnonie();
  clearFilterStationsWinnonie();
  clearFilterBatteriesWinnonie();
  clearFilterBatteryLogsWinnonie();
  clearFilterEvLockersBrandWinnonie();
  clearFilterEvLockerLogsBrandWinnonie();
  clearFilterStationLogsBrandWinnonie();
  clearFilterTransactionsBrandWinnonie();
};
export const clearFilterProjectLevel = () => {
  clearFilterProjectEndUser();
  clearFilterEvLockersProjectWinnonie();
  clearFilterStationLogsProjectWinnonie();
  clearFilterEvLockerLogsProjectWinnonie();
  clearFilterTransactionsProjectWinnonie();
};

export const clearAllFilters = () => {
  clearFilterBrandLevel();
  clearFilterProjectLevel();
};
